// Models
import { FloatingDay } from "./FloatingDay";
/**
 * Represents a yearly floating day.
 * @example Fourth Thursday of November for Thanksgiving.
 */ export class YearlyFloatingDay extends FloatingDay {
    getMonthForPeriod(_) {
        return this.month;
    }
    /**
     * Constructs a new YearlyFloatingDay instance.
     *
     * @param month - The month of the date (1-indexed, e.g., 11 for November).
     * @param relativeWeekIndex - The relative week in the month.
     * @param dayOfWeek - The day of the week (e.g., Thursday).
     *
     * @example
     * // Represents the fourth Thursday of November (Thanksgiving in the US)
     * const thanksgiving = new YearlyFloatingDay(11, RelativeWeekIndex.Fourth, DayOfWeek.Thursday);
     */ constructor(month, relativeWeekIndex, dayOfWeek){
        super(relativeWeekIndex, dayOfWeek), this.month = month;
    }
}
